import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { portfolio } from "@/content/siteContent";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export default function Portfolio() {
  const [filter, setFilter] = useState("TODOS");
  const items = filter === "TODOS" ? portfolio.items : portfolio.items.filter((i) => i.category === filter);

  return (
    <section id="portfolio" className="honeycomb bg-ink py-24 md:py-32" data-testid="portfolio-section">
      <div className="relative z-10 mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading
          chapter={portfolio.chapter}
          microtitle={portfolio.microtitle}
          titleA={portfolio.titleA}
          titleB={portfolio.titleB}
        />

        <Reveal>
          <div className="mb-10 flex flex-wrap gap-2.5" data-testid="portfolio-filters">
            {portfolio.filters.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                className={`rounded-full border px-5 py-2.5 font-display text-[0.68rem] font-extrabold tracking-[0.14em] transition-[background-color,border-color,color] duration-300 ${
                  filter === f
                    ? "border-brand bg-brand text-ink"
                    : "border-metal bg-graphite text-mist hover:border-brand/60 hover:text-brand"
                }`}
                data-testid={`portfolio-filter-${f.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")}`}
              >
                {f}
              </button>
            ))}
          </div>
        </Reveal>

        <motion.div layout className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <AnimatePresence mode="popLayout">
            {items.map((item) => (
              <motion.article
                layout
                key={item.title}
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.35 }}
                className="group relative h-64 overflow-hidden rounded-[20px] border border-metal md:h-72"
                data-testid={`portfolio-item-${item.category.toLowerCase()}`}
              >
                <img
                  src={item.img}
                  alt={item.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/95 via-ink/20 to-transparent opacity-90 transition-opacity duration-300 group-hover:opacity-100" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <p className="microtitle !text-[0.62rem]">{item.category}</p>
                  <h3 className="mt-2 font-display text-base font-extrabold leading-snug text-paper md:text-lg">
                    {item.title}
                  </h3>
                </div>
              </motion.article>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
}
